import { Box, Center } from "@chakra-ui/layout"
import React, { Fragment } from "react"
import styled from "styled-components"

import { GetAuthRegister } from "~/api/auth/register/get"
import { CheckItem } from "~/components/atoms/Checkbox"
import Icon from "~/components/atoms/Icon"
import { SelectModalContainer } from "~/components/molecules/SelectModal"
import { StyledInputLike } from "~/components/molecules/SelectboxMultiple"
import { Color, SpacingSize } from "~/consts/style-mixins"

import { FormContainer } from "../FormContainer"
import { useFormSelectboxForOccupations } from "./useFormSelectboxForOccupations"

const LABEL = "興味のある職種"

export type FormSelectboxForOccupationsProps = {
  occupations: GetAuthRegister["occupations"]
  selectedForMajorOccupationIds: Array<string | number>
  selectedForMinorOccupationIds: Array<string | number>
  onChangeForMajorOccupationIds?: (ids: Array<string>) => void
  onChangeForMinorOccupationIds?: (ids: Array<string>) => void
  error?: string
  isCampaignRequire?: boolean
  isCampaignRecommend?: boolean
}

export const FormSelectboxForOccupations = (props: FormSelectboxForOccupationsProps) => (
  <FormContainer
    label={LABEL}
    errorMessage={props.error}
    isCampaignRecommend={props.isCampaignRecommend}
    isCampaignRequire={props.isCampaignRequire}
  >
    <SelectboxOccupations {...props} />
  </FormContainer>
)

export const SelectboxOccupations = (props: FormSelectboxForOccupationsProps) => {
  const {
    selectedMajorOccupationDict,
    onClickForMajorOccupations,
    selectedMinorOccupationDict,
    onClickForMinorOccupations,
    textForInputLike,
    isShownModal,
    onInputClick,
    onCompleteClick,
    onCancelClick,
  } = useFormSelectboxForOccupations(props)

  return (
    <>
      <Box position="relative">
        <StyledInputLike onClick={onInputClick} error={!!props.error}>
          {textForInputLike}
        </StyledInputLike>
        <Center h="100%" position="absolute" top={0} right={16}>
          <Icon type="Open" size={16} color={Color.Gray} />
        </Center>
      </Box>
      {isShownModal && (
        <SelectModalContainer
          labelName={LABEL}
          note="できるだけ各職種の小分類も選択してください"
          mainAction={{
            label: "確定する",
            action: onCompleteClick,
          }}
          subAction={{
            label: "キャンセル",
            action: onCancelClick,
          }}
        >
          {props.occupations.map(({ id, name, minor_occupations }) => {
            const isSelected = selectedMajorOccupationDict[id]

            return (
              <Fragment key={`${id}_parent`}>
                <StyledCheckItem
                  key={id}
                  type="Medium"
                  text={name}
                  isChecked={!!isSelected}
                  onClick={() => onClickForMajorOccupations(id, isSelected)}
                />
                {isSelected && (
                  <Box key={`${id}_nested`} my={SpacingSize.XS} ml={SpacingSize._3XL}>
                    {minor_occupations.map(({ id: minorOccupationId, name: minorOccupationName }) => (
                      <StyledCheckItem
                        key={`${id}-${minorOccupationId}`}
                        type="Medium"
                        text={minorOccupationName}
                        isChecked={!!selectedMinorOccupationDict[minorOccupationId]}
                        onClick={() => onClickForMinorOccupations(minorOccupationId)}
                      />
                    ))}
                  </Box>
                )}
              </Fragment>
            )
          })}
        </SelectModalContainer>
      )}
    </>
  )
}

// NOTE: `transition: none;`を追記しないとmargin-topにtransitionがかかる
const StyledCheckItem = styled(CheckItem)`
  & + & {
    margin-top: ${SpacingSize.XS}px;
    transition: none;
  }
`
